<template>
  <div>
    <div id="top-offer">
      <header-menu
        :show-hours="false"
        :regenerate-links="componentReady"/>
      <div
        class="offer-container"
        v-if="metaLoaded">
        <sports-header
          v-if="componentReady"
          :limit="appSettings.maxSports"/>
        <div
          class="top-offer"
          v-if="showOffer">
          <tournament-filter
            v-if="showTournamentFilter"
            :categories="categories"
            :tournaments="tournamentsBySport(Object.keys(tournaments)
            .map(i => tournaments[i]), selectedSport.id)"
            :sport-id="selectedSport.providerId"
            @selectedTournament="tournamentSelected"/>
          <scroller v-if="matches">
            <div
              class="matches-wrapper"
              ref="matchesWrapper"
              v-max-height="{
              el: ['.header-menu', '.sports-header', '.tournaments', '.footer'], offset: 20 }">
              <div
                v-for="(match, index) in matches"
                :key="match.id">
                <header-bets
                  v-if="showHeaderBets(match, index)"
                  :sport="selectedSport.id"
                  :category="categories[match.idCategory]"
                  :tournaments="tournaments"
                  :tournament="tournaments[match.idTournament]"/>
                <div class="match-row">
                  <match
                    :match="match"
                    :top-offer="1"/>
                </div>
              </div>
            </div>
          </scroller>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Moment from 'moment';
import HeaderMenu from '../../shared/header-menu/HeaderMenu.vue';
import HeaderBets from '../../shared/header-bets/HeaderBets.vue';
import TournamentFilter from '../../shared/tournament-filter/TournamentFilter.vue';
import Match from '../../shared/Match.vue';
import mixins from '../../../mixins';
import parser from '../../../services/parser';
import SportsHeader from '../../shared/sports-header/SportsHeader.vue';

export default {
  computed: {
    appSettings() {
      return this.$store.getters.getCompanyConfig;
    },
    selectedSport() {
      return this.$store.getters.getActiveSport;
    },
    selectedTournament() {
      return this.$store.getters.getActiveTournament;
    },
    topOffer() {
      return this.$store.getters.getTopOffer;
    },
    matches() {
      if (this.selectedTournament) {
        const tourIds = this.$store.getters.getChildTournamentsForOffer(
          this.selectedTournament.id,
        ).map(item => item.id);

        if (!_.isEmpty(tourIds)) {
          return _.filter(
            this.topOffer.matches, match => _.includes(tourIds, match.idTournament),
          );
        }
        return _.filter(this.topOffer.matches, { idTournament: this.selectedTournament.id });
      }

      return _.filter(this.topOffer.matches, this.filterBySport);
    },
    tournaments() {
      return this.topOffer.tournaments;
    },
    categories() {
      return this.topOffer.categories;
    },
    metaLoaded() {
      return this.$store.getters.getMetaLoaded;
    },
    offerLoaded() {
      return this.$store.getters.getOfferLoaded;
    },
    componentReady() {
      return this.metaLoaded && this.offerLoaded;
    },
    bets() {
      return this.$store.getters.getAllBets;
    },
    selectedProviderId() {
      return this.selectedSport && parseInt(this.selectedSport.providerId, 10);
    },
    showTournamentFilter() {
      return this.selectedSport && this.selectedSport.providerId;
    },
    showOffer() {
      return this.topOffer && this.topOffer.matches && this.metaLoaded;
    },
  },
  components: {
    Match,
    HeaderBets,
    TournamentFilter,
    HeaderMenu,
    SportsHeader,
  },
  mixins: [mixins],
  beforeCreate() {
    this.$store.dispatch('toggleMetaLoad', false);
  },
  mounted() {
    const dateFormat = 'YYYY-MM-DD HH:mm:ss';
    const startDate = new Moment();
    const endDate = new Moment(startDate).add(20, 'days');
    endDate.endOf('day');

    this.$store.dispatch('fetchTopOffer', {
      params: {
        start_date: Moment.utc(startDate).format(dateFormat),
        end_date: Moment.utc(endDate).format(dateFormat),
        bet_count: 3,
      },
      topOffer: {
        matches: true,
      },
    });
  },
  methods: {
    tournamentsBySport(tournaments, idSport) {
      return _.orderBy(
        _.filter(tournaments, item => item.idSport === idSport && !item.parent),
        ['categoryPosition', 'position'],
      );
    },
    showHeaderBets(match, index) {
      return (this.tournaments && this.selectedSport)
        && ((index === 0) || (match.idTournament !== this.matches[index - 1].idTournament));
    },
  },
  watch: {
    componentReady(newVal) {
      if (newVal) {
        parser.mapMatchBets(this.topOffer.matches, this.bets);
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    // Reset selected sport
    if (to.name === 'Offer') {
      this.$store.dispatch('setActiveSport', {});
    }
    next();
  },
};
</script>
<style lang="scss">
@import '../../../scss/default/modules/offer';
</style>
